module.exports = __webpack_public_path__ + "img/Canceled_Payment.64eb39a8.svg";